'use es6';

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import options from './Options';
const reducers = combineReducers({
  options
});

let _state = SeamlessImmutable({});

export default ((state, action) => {
  _state = SeamlessImmutable.merge(_state, reducers(state, action));
  return _state;
});